import style from "./BodySchema.module.css";
import { useContext, useState } from "react";
import TextAreaField from "./TextAreaField";
import inputStyle from "./InputStyles.module.css";
import { FormContext } from "./FormField";
import styles from "./Webhook.module.css";

const sampleSchema = `
Build valid JSON data structure for body request
example:
  {
    state:"Cauca",
    city:"Popayan",
    Nation:"Colombia"
  }

1){
    "location": {
      "origin": {
        "state": null,
        "city": null,
        "country": "$$Nation",
      }
      ...
  }

This takes up the entire request data
2) {data:{...body}} or {data:[[...body]]}

`;

const sampleExample = {
  work: {
    name: null,
    company: null,
    role: null,
  },
  teamMembers: null,
};

function BodySchema() {
  const warningColor: string[] = ["green", "red"];
  const { fields, setValue } = useContext(FormContext);
  const [boxColor, setBoxColor] = useState(warningColor[0]);
  return (
    <div className={styles.card}>
      <TextAreaField
        name="schema"
        label={<h2>Esquema de datos</h2>}
        inputClassName={`${inputStyle.input} ${style.schemaTextBox}`}
        placeholder={sampleSchema}
        inputStyle={{
          border: `2px solid ${boxColor}`,
          minHeight: "250px",
          outlineColor: boxColor,
        }}
        initialValue={JSON.stringify(fields.schema, undefined, 4)}
        onChange={(e) => {
          try {
            const jsonData = JSON.parse(e.target.value);
            setValue({ schema: jsonData });
            setBoxColor(warningColor[0]);
          } catch (error) {
            setBoxColor(warningColor[1]);
          }
        }}
      />
    </div>
  );
}

export default BodySchema;
